// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"0c0faaa7","447":"1aef7181","799":"4e3bdc36","845":"6bad9f47","984":"60ad88cc"}[chunkId] + ".chunk.js";
};